import React from "react";
import TagCombobox from "./TagCombobox";

// Tag picker used when creating/editing an order: lets the user pick existing
// tags or create a new one on the fly.
export default function AutocompleteTagInput({ selectedTags, setSelectedTags }) {
  return (
    <TagCombobox
      selectedTags={selectedTags}
      setSelectedTags={setSelectedTags}
      placeholder="חפש תג…"
      triggerLabel="חפש/הוסף תג…"
      triggerAriaLabel="בחר תגיות"
      allowCreate
    />
  );
}
